import { step01Lose } from "./step_01_lose";
import type { GambleFlow } from "@slot/game-shell";

/** First gamble loses. Verifies the lose path. */
export const flowImmediateLose: GambleFlow = [step01Lose];
